import { fabric } from "fabric";

/**
 * 图片加载任务优先级枚举
 * 数值越大优先级越高
 */
export enum LoadPriority {
  /** 视口外图片 - 最低优先级 */
  OUT_OF_VIEWPORT = 0,
  /** 视口内图片 - 中等优先级 */
  IN_VIEWPORT = 1,
  /** Gallery图片但不在视口内 - 较高优先级 */
  GALLERY_OUT_VIEWPORT = 2,
  /** Gallery图片且在视口内 - 最高优先级 */
  GALLERY_IN_VIEWPORT = 3
}

/**
 * 单个占位符与原始数据的映射
 */
export interface PlaceholderMapping {
  placeholder: fabric.Object; // 占位符对象
  originalObj: any; // 原始图片数据对象
  index: number; // 原始对象索引
}

export interface ImageLoadTask {
  id: string; // 唯一标识，对应图片的 URL
  mappings: PlaceholderMapping[]; // 该URL对应的所有占位符映射（支持一对多）
  priority: LoadPriority; // 优先级
  retries: number; // 当前重试次数
  /** 是否在视口内（缓存状态，只要有任一在视口内就为true） */
  inViewport: boolean;
}

/**
 * 待更新渲染的任务
 */
export interface UpdateTask {
  mappings: PlaceholderMapping[];
  imgElem: HTMLImageElement;
}
